import {Component, OnInit, ViewChild} from '@angular/core';
import {IonSearchbar, ModalController} from '@ionic/angular';

@Component({
  selector: 'app-modal-test',
  templateUrl: './modal-test.page.html',
  styleUrls: ['./modal-test.page.scss'],
})
export class ModalTestPage implements OnInit {

  @ViewChild('suche', {static: false}) suche: IonSearchbar;

  constructor(private modalCtrl: ModalController) { }

  ngOnInit() {
  }

  ionViewWillEnter() {
    this.viewWillEnterPage().then();
  }

  async viewWillEnterPage() {
    setTimeout(() => {
            if (this.suche) {
                this.suche.setFocus();
            }
        }, 500);
  }

  async abbrechen() {
    await this.modalCtrl.dismiss();
  }

}
